export const SETTINGS = [
  {
    apiName: "companyName",
    component: "FrmCompanyName",
  },
  {
    apiName: "legalAddress",
    component: "LegalAddress",
  },
  { apiName: "companyHeader", component: "FrmResizeTextField" },
];
